<div class="conf-action">
    <div class="conf-desktop-disclaimer">
        <ng-container *ngIf="stepTitle == 'Cabin Type'">
            <div class="conf-disclaimer-row">
                <img src="{{confAWSUrlStr}}/common/image_disclaimer.svg" alt="image-disclaimer">
                <p class="conf-p-center">
                    Exact availability of cabin types and colours shall be confirmed by your nearest Tata Motors authorized dealer
                </p>
            </div>
        </ng-container>
        <ng-container *ngIf="stepTitle == 'Value Added Services' || stepTitle == 'Base Vehicle'">
            <div class="conf-disclaimer-row">
                <img src="{{confAWSUrlStr}}/common/vas_disclaimer.svg" alt="image-disclaimer">
                <p class="conf-p-center">
                    Some features may not be available in all states/markets, please contact your dealer for availability. Specifications, features, design, colour, services, offer details are liable to change without any prior notice.
                </p>
            </div>
        </ng-container>
        <ng-container *ngIf="stepTitle == 'Base Vehicle'">
            <div class="conf-disclaimer-row">
                <img src="{{confAWSUrlStr}}/common/price_disclaimer.svg" alt="price-disclaimer">
                <p class="conf-p-center">
                    Prices shown are Ex-Showroom. Final offer price will be given by dealer.
                </p>
            </div>
        </ng-container>
        <ng-container *ngIf="stepTitle == 'Additional Features'">
            <div class="conf-disclaimer-row">
                <img src="{{confAWSUrlStr}}/common/product_disclaimer.svg" alt="product-disclaimer">
                <p>
                    Please consult your Tata Motors commercial vehicle dealership for final details, feature benefits and final price etc.
                </p>
            </div>
        </ng-container>
        <div class="conf-disclaimer-row">
            <img src="{{confAWSUrlStr}}/common/image_disclaimer.svg" alt="image-disclaimer">
            <p class="conf-p-center">
                Images, video used in the configurator are representational and may differ in actual vehicle. The illustrations may also include accessories and optional extras that are not included in the standard specification and are out of the scope of delivery.
            </p>
        </div>
        <div class="conf-disclaimer-row-for-more">
            <img  class="conf-image-disclaimer"src="{{confAWSUrlStr}}/common/Vector.svg" alt="price-disclaimer">
            <p class="conf-p-center">For more details or clarifications, please reach out to your nearest dealership or contact us at <a href = "mailto: cac@tatamotors.com">cac@tatamotors.com</a> toll free no. <a href = "tel: 1800 209 7979">1800 209 7979</a>.</p>
        </div>
    </div>
</div>
